/**
 * 認識 XRROSS／對外介紹：頂欄常駐（非側欄；不進 coffee_menu）
 * patch 222 已刪 990440–442 側欄節點；990440 已被 patch 223 設備需求單「查看」占用。
 * hubId 僅 route meta 合成碼，禁止寫入 sidebarMenuIdSsot／禁止當 DB 選單 id。
 */
export const XRROSS_INTRO_ROUTE = {
  hubId: 990441,
  hubEnName: 'xrrossIntroHub',
  groupEnName: 'xrrossIntroGroup'
}

/** @deprecated 僅相容舊 import；勿再當側欄／授權樹 id */
export const XRROSS_INTRO_MENU_IDS = {
  hub: XRROSS_INTRO_ROUTE.hubId
}

export default XRROSS_INTRO_ROUTE



// WEBPACK FOOTER //
// C:/Users/xiaolan/Desktop/Android/Xrross-SOC-Frontend/E:/xrross/Android/Xrross-SOC-Frontend/src/constants/xrrossIntro.js